/* eslint-disable prettier/prettier */
/* eslint-disable */

import { combineReducers } from '@reduxjs/toolkit';

import { IMetaData } from '../api/types';

import auth from './auth';
import attachment from './attachment';
import attachmentTemplate from './employee/attachmentTemplate';
import currentStudent from './currentStudent';
import currentUser from './user';
import displayedEntityCount from './displayedEntityCount';
import linkError from './linkError';
import linkMode from './linkMode';
import olympiadLevels from './olympiadLevels';
import olympiadResults from './olympiadResults';
import olympiadParallels from './employee/olympiadParallels';
import olympiadTypes from './employee/olympiadTypes';
import olympiadFormats from './olympiadFormats';
import studentGiaList from './student/studentGiaList';
import studentShareLink from './student/studentShareLink';
import studentShareLinkList from './student/studentShareLinkList';
import studentDiagnosis from './student/studentDiagnosis';
import studentIndependentDiagnosis from './student/studentIndependentDiagnosis';
import independentDiagnostics from './diagnostic/independentDiagnostics';
import personalDiagnostics from './diagnostic/personalDiagnostics';
import independentDiagnosticsGeneralRating from './diagnostic/independentDiagnosticsGeneralRating';
import independentDiagnosticsRating from './diagnostic/independentDiagnosticsRating';
import independentDiagnosisSettings from './independentDiagnosisSettings';

import pdfStudentDiagnosisFull from './student/pdfStudentDiagnosisFull';
import pdfStudentDiagnosisYear from './student/pdfStudentDiagnosisYear';
import feedbackLink from './feedBackLink';
import linkVisibilitySettings from './linkVisibilitySettings';
import userSettings from './userSettings';
import localVisibilitySettings from './localVisibilitySettings';
import cultureVisitings from './student/cultureVisitings';

import affilationKinds from './employee/affilationKinds';
import eventKinds from './employee/eventKinds';
import sportKinds from './employee/sportKinds';
import tourismKinds from './employee/tourismKinds';
import creationKinds from './employee/creationKinds';
import culturalKinds from './employee/culturalKinds';
import rewardKinds from './employee/rewardKinds';
import portfolioSubcategories from './employee/subcategories';
import statusRewards from './employee/statusRewards';
import projectFormats from './employee/projectFormats';
import personsObjects from './employee/personObjects';
import disciplines from './employee/disciplines';
import museums from './employee/museums';
import theatres from './employee/theatres';
import cinemas from './employee/cinemas';
import sportClubs from './employee/sportClubs';
import sportTrainingStage from './employee/sportTrainingStage';
import sportRewardKinds from './employee/sportRewardKinds';
import organizations from './employee/organizations';
import parallels from './employee/parallels';
import personsList from './employee/persons';
import history from './employee/history';
import importHistory from './employee/importHistory';
import importList from './employee/importList';

import studentEvents from './student/events';
import studentRewards from './student/rewards';
import studentProjects from './student/projects';
import studentEmployments from './student/employments';
import studentSportRewards from './student/sportRewards';
import studentAffilations from './student/affilations';
import studentGiaWorldSkills from './student/giaWorldSkills';
import studentRecommendations from './student/recommendations';
import studentClassRecommendations from './student/classRecommendations';
import studentEisDopRecommendations from './student/eisDopRecommendations';
import studentCheckInHistory from './student/checkInHistory';
import historyFormEntity from './employee/historyFormEntity';
import historyFormEditStatus from './employee/historyFormEditStatus';
import reportErrorStatus from './student/reportError';
import entityErrorMessages from './student/entityErrorMessages';
import gratitudeTeacherStatus from './student/gratitudeTeacher';
import avatars from './student/avatars';
import studentJobs from './student/studentJobs';
import studentSpoEducation from './student/studentSpoEducation';
import studentSpoDocuments from './student/studentSpoDocuments';

import adminSettings from './admin/adminSettings';
import adminViewModeSettings from './admin/viewModeSettings';
import learnerCategories from './admin/learnerCategories';
import settingSections from './admin/settingSections';
import adminHistory from './admin/adminHistory';
import adminDeleteHistory from './admin/adminDeleteHistory';
import actionKinds from './admin/actionKinds';
import adminFunctionSettings from './admin/adminFunctionSettings';
import adminViewMode from './admin/viewMode';
import sources from './sources';

import studentInterests from './interests/interests';
import interestHeadKinds from './interests/interestHeadKinds';
import interestActionKinds from './interests/interestActionKinds';
import interestGroupKinds from './interests/interestGroupKinds';
import interestObjectKinds from './interests/interestObjectKinds';
import archivedInterestObjectKinds from './interests/archivedInterestObjectKinds';

import viewedFunctions from './viewedFunctions';
import viewedFunctionsRequest from './viewedFunctionsRequest';
import studentProfessionalAdditionalEducation from './student/studentProfessionalAdditionalEducation';
import studentMetaSkills from './student/studentMetaSkills';
import studentSpoStatus from './student/studentSpoStatus';
import studentPersonalAccess from './student/studentPersonalAccess';

import parallelCurricula from './dnevnik/parallelCurricula';

import userThemeSettings from './theme/settings';
import boundaryError from './boundaryError';
import applicationStatus from './applicationStatus';

import navigationSection from './navigationSection';

import {
  sectionRef,
  documentRef,
  metaSkillRef,
  professionProgrammRef,
  levelBusinessRef,
  salaryRangeRef,
  employmentDocTypeRef,
  spoOrganizationRef,
  spoGiaMarkRef,
  professionRankRef,
  sportAgesRef,
  olympiadSubjectsRef,
  avatarTypeRef,
} from './reference';

import dataEntryDrawer, { DataEntryDrawerState } from './drawers/dataEntryDrawer';
import detailViewDrawer, { DetailViewDrawerState } from './drawers/detailViewDrawer';
import linkSharingDrawer, { LinkSharingDrawerState } from './drawers/linkSharingDrawer';
import reportErrorDrawer, { ReportErrorDrawerState } from './drawers/reportErrorDrawer';
import thanksTeacherDrawer, { ThanksTeacherDrawerState } from './drawers/thanksTeacherDrawer';
import eisDopRecommendationsDrawer, { EisDopRecommendationsDrawerState } from './drawers/eisDopRecommendationsDrawer';

import { vuzRecommendationModel, vuzRecommendationModelTypes } from 'portfolio3/features/vuzRecommendation';
import { proforientationModel, proforientationModelTypes } from 'portfolio3/features/proforientation';
import { searchModel, searchModelTypes } from 'portfolio3/features/search';
import { performanceModel, performanceModelTypes } from 'portfolio3/features/performance';
import { performanceOldModel, performanceOldModelTypes } from 'portfolio3/features/performanceOld';
import { yandexMetrikaModel } from 'portfolio3/features/yandexMetrika';
import { Action } from 'actions/utils';
import { configReducer, widgetsReducer } from 'slices';

export type RequestState = 'request' | 'failure' | 'success';

export interface GenericResponseData<T> extends IMetaData {
  content: T;
  loading?: boolean;
  more?: boolean;
}

export type IReducers<S> = Record<string, (state: S, action: Action<any>) => S>;

export type IRootState = ReturnType<typeof rootReducer>;

const rootReducers = {
  currentUser,
  currentStudent,
  auth,
  attachment,
  attachmentTemplate,
  adminSettings,
  adminViewModeSettings,
  adminFunctionSettings,
  adminViewMode,
  adminHistory,
  adminDeleteHistory,
  actionKinds,
  cultureVisitings,
  displayedEntityCount,
  linkError,
  linkMode,
  linkVisibilitySettings,
  localVisibilitySettings,
  olympiadFormats,
  olympiadLevels,
  olympiadParallels,
  olympiadResults,
  olympiadTypes,
  pdfStudentDiagnosisFull,
  pdfStudentDiagnosisYear,
  studentDiagnosis,
  studentIndependentDiagnosis,
  independentDiagnostics,
  personalDiagnostics,
  independentDiagnosticsGeneralRating,
  independentDiagnosticsRating,
  independentDiagnosisSettings,
  studentGiaList,
  studentShareLink,
  studentShareLinkList,
  feedbackLink,
  visibilitySettings: userSettings,
  portfolioSubcategories,
  statusRewards,
  projectFormats,
  affilationKinds,
  eventKinds,
  sportKinds,
  sportRewardKinds,
  tourismKinds,
  creationKinds,
  culturalKinds,
  rewardKinds,
  disciplines,
  personsObjects,
  museums,
  theatres,
  cinemas,
  sportClubs,
  sportTrainingStage,
  organizations,
  parallels,
  personsList,
  studentEvents,
  studentRewards,
  studentProjects,
  studentEmployments,
  studentSportRewards,
  studentAffilations,
  studentGiaWorldSkills,
  studentRecommendations,
  studentClassRecommendations,
  studentEisDopRecommendations,
  studentProfessionalAdditionalEducation,
  studentJobs,
  studentMetaSkills,
  studentSpoEducation,
  studentSpoStatus,
  studentPersonalAccess,
  parallelCurricula,
  studentSpoDocuments,
  history,
  historyFormEntity,
  historyFormEditStatus,
  reportErrorStatus,
  entityErrorMessages,
  gratitudeTeacherStatus,
  avatars,
  importHistory,
  studentCheckInHistory,
  importList,
  learnerCategories,
  settingSections,
  sources,
  studentInterests,
  interestHeadKinds,
  interestActionKinds,
  interestGroupKinds,
  interestObjectKinds,
  archivedInterestObjectKinds,
  viewedFunctions,
  viewedFunctionsRequest,
  userThemeSettings,
  boundaryError,
  applicationStatus,
  sectionRef,
  documentRef,
  metaSkillRef,
  professionProgrammRef,
  levelBusinessRef,
  salaryRangeRef,
  employmentDocTypeRef,
  spoOrganizationRef,
  spoGiaMarkRef,
  professionRankRef,
  sportAgesRef,
  olympiadSubjectsRef,
  avatarTypeRef,
  dataEntryDrawer,
  detailViewDrawer,
  linkSharingDrawer,
  reportErrorDrawer,
  thanksTeacherDrawer,
  eisDopRecommendationsDrawer,
  navigationSection,
  ...vuzRecommendationModel.reducers.collection,
  ...proforientationModel.reducers.collection,
  ...searchModel.reducers.collection,
  ...performanceModel.reducers.collection,
  ...performanceOldModel.reducers.collection,
  ...yandexMetrikaModel.reducers.collection,
  config: configReducer,
  widgets: widgetsReducer,
};

const rootReducer = combineReducers(rootReducers);
export default rootReducer;
